module.exports = __webpack_public_path__ + "static/goldm_3_2-f3e3024e4e9e797d99cd4e574b00cb05.mp4";